import { apiHost } from '../../../config';
import { post } from '../../requests';
import Teacher from '../../../types/Teacher';

export default async function createTeacher(teacher: Omit<Teacher, 'id'>) {
  return post(`${apiHost}/api/admin/users`, teacher);
}
